<!-- TEMPLATE -->
<template>
  <span>
    <div
      class="dean-header-item-dropdown"
      @mouseover="dropdownOpen = true"
      @mouseleave="dropdownOpen = false"
    >
      <dean-header-profile
        v-if="profile === true"
        :img="img"
        :active="deanHeaderItemDropdownState || active"
        @dean-header-item-click="itemClicked"
      >
        {{ text }}
      </dean-header-profile>
      <dean-header-item
        v-else
        :icon="icon"
        :active="deanHeaderItemDropdownState || active"
        @dean-header-item-click="itemClicked"
      >
        {{ text }}
      </dean-header-item>
      <transition name="dropdown-menu" mode="in-out" appear>
        <span v-if="dropdownOpen" :class="deanHeaderItemDropdownContent">
          <slot class="dean-header-item-dropdown-content-slot"></slot>
        </span>
      </transition>
    </div>
    <span
      v-if="dropdownOpen && userAgentIpad"
      @click="dropdownOpen = false"
      class="clickToClose"
    >
    </span>
  </span>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop, Watch, Emit } from 'vue-property-decorator';

// SVG
import moreApps from '../svg/feather-icons/grid.svg';

// COMPONENTS
import deanIcon from './deanIcon.vue';
import deanHeaderItem from './deanHeaderItem.vue';
import deanHeaderProfile from './deanHeaderProfile.vue';

@Component({
  components: {
    deanHeaderItem,
    deanHeaderProfile
  }
})
export default class deanHeaderItemDropdown extends Vue {
  // PROPS
  @Prop() active!: boolean;
  @Prop() state!: string;
  @Prop() icon!: object;
  @Prop() img!: string;
  @Prop() text!: string;
  @Prop() dropdownType!: string;
  @Prop() theme!: string;
  @Prop({ default: false })
  profile!: boolean;
  @Prop({ default: false })
  grid!: boolean;
  @Prop({ default: false })
  list!: boolean;

  // DATA
  moreApps: object = moreApps;
  dropdownOpen: boolean = false;

  // WATCH
  @Watch('dropdownOpen')
  dropdown() {
    /*
    if (this.dropdownOpen == false) {
      var self = this
      setTimeout(() => {
        self.dropdownOpen = false;
      }, 2000);

    } 
    */
  }

  @Watch('$route')
  closeDropdown() {
    this.dropdownOpen = false;
  }

  // EMIT
  @Emit('dean-header-item-click')
  itemClicked(data: string) {
    console.log(data);
  }
  
  // COMPUTED
  get userAgentIpad() {
    if (String(navigator.userAgent).includes('iPad')) {
      return true;
    } else {
      return false;
    }
  }
  get deanHeaderItemDropdownContent() {
    let value = 'dean-header-item-dropdown-content';
    /* Theme */
    if (this.grid) value += ` dean-header-item-dropdown-content-grid`;
    if (this.list) {
      value += ` dean-header-item-dropdown-content-list`;
    } else {
      value += ` dean-header-item-dropdown-content-grid`;
    }
    if (this.dropdownType) {
      value += ` dean-header-item-dropdown-content-l${this.dropdownType}`;
    }
    return value;
  }

  get deanHeaderItemDropdownState() {
    if (this.state == 'active') {
      return true;
    } else {
      return false;
    }
  }

  mounted() {
    this.dropdownOpen = false;
    console.log(String(navigator.userAgent));
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

// DEAN HEADER ITEM DROPDOWN
.dean-header-item-dropdown {
  display: inline-block;
  height: 100%;
  cursor: pointer;
  margin: 0;
  padding: 0;
  z-index: 2;
  /*
  &:hover .dean-header-item-dropdown-content {
    top: 100%;
    opacity: 1;
    @include visibility(visible);
  }
  */

  .dean-header-item-dropdown-content {
    position: absolute;
    height: auto;
    background-color: white;
    text-align: center;
    border: 1px solid var(--color-light, $color-light);
    @include border-radius(10px);
    @include box-shadow(3px 3px 5px rgba(0, 0, 0, 0.075));
    z-index: 2;
    // opacity: 0;
    // @include visibility(hidden);
    // @include calc(top, 100% - 25%);
    // @include transition(all 0.5s ease);

    &:before {
      content: ' ';
      position: absolute;
      bottom: 100%;
      margin-left: -12px;
      border-width: 12px;
      border-style: solid;
      border-color: transparent transparent var(--color-light, $color-light)
        transparent;
    }

    &:after {
      content: ' ';
      position: absolute;
      bottom: 100%;
      margin-left: -10px;
      border-width: 10px;
      border-style: solid;
      border-color: transparent transparent white transparent;
    }

    /*
    .dean-header-item-dropdown-content-slot {
      @include visibility(hidden);
    }
    */
  }

  .dean-header-item-dropdown-content-grid {
    top: 72.5px;
    margin-left: -180px;
    padding: 10px;
    width: 264px;
    // MOZILLA
    @-moz-document url-prefix() {
      margin-left: -260px !important;
    }
    // CHROME 29+
    @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
      margin-left: -260px !important;
    }
    &:before,
    &:after {
      left: 220px;
    }
  }

  .dean-header-item-dropdown-content-list {
    top: 72.5px;
    margin-left: -120px;
    width: 200px;
    // MOZILLA
    @-moz-document url-prefix() {
      margin-left: -200px !important;
    }
    // CHROME 29+
    @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
      margin-left: -200px !important;
    }
    &:before,
    &:after {
      left: 160px;
    }
  }
}

.clickToClose {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  min-width: 100%;
  min-height: 100%;
  z-index: 1;
}
</style>
